module.exports = __webpack_public_path__ + "img/hui.759183ed.png";